import React, { useEffect, useState } from 'react'
import SimpleSelect from '../SimpleSelect'
import { useDispatch } from 'react-redux';
import { getIntelSetting, intentSetting } from '../../redux/actions/settingActions';
import { useSelector } from 'react-redux';

const SettingAdvanceIntent = (props) => {
  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(getIntelSetting(props.authToken));
  },[])
  
  
  const [searchEngine,setSearchEngine]=useState();
  const [selectedAi,setSelectedAi]=useState({ id: 1, name: "Claude" });
  const [selectedSortBy,setSelectedSortBy]=useState({ id: 1, name: "Date" });
  const [humanResponse,setHumanResponse]=useState("");
  const intSetting = useSelector((state) => state.setting.intelSetting?.data);
  
  function getAIOptionByName(name) {
    const [result] = aiOptions.filter(option => option.name === name);
    return result;
  }
  useEffect(()=>{
    if(intSetting?.search_engine?.length > 0){
      setSearchEngine(intSetting?.search_engine)
      setHumanResponse(intSetting?.human_prompt)
      const result = getAIOptionByName(intSetting?.llm);
      setSelectedAi(result)
      setSelectedSortBy(intSetting?.sort_by == "Date" ? { id: 1, name: "Date" } : { id: 2, name: "Relevance" })
    }
  },[intSetting])



    
    const notificationMethods = [
        { id: 'Bing News Search API', title: 'Bing' },
        // { id: 'GNews', title: 'GNews' },
      ]
      const aiOptions = [
        { id: 1, name: "Claude" },
        { id: 2, name: "OpenAI" },
        { id: 3, name: "Gemini" },
      ];
      const sortByOptions = [
        { id: 1, name: "Date" },
        { id: 2, name: "Relevance" },
      ];

      const handleSubmit = () =>{
        dispatch(intentSetting(props.authToken,searchEngine,selectedAi?.name,selectedSortBy?.name,humanResponse ));
      }




  return (
    <>
    <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
            <div className="text-lg leading-7 font-[500] my-auto">Intel Setting</div>  
            <button
              type="button"
              className="mr-4 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
              onClick={()=>{handleSubmit();}}
            >
            Save Changes
          </button>            
          </div>
    <div className='flex flex-col bg-white my-4 py-4 px-5'>
        {/* <div className='flex flex-col border-gray-200  border-solid border-[1px] py-3 px-2 rounded-md'>
            <div className='text-xs'>Choose News Search Engines:</div>
            <div className="mt-2 ml-2 space-y-2">
        {notificationMethods.map((notificationMethod) => (
          <div key={notificationMethod.id} className="flex items-center">
            <input
              checked={searchEngine === notificationMethod.id}
              id={notificationMethod.id}
              name="notification-method"
              type="radio"
              className="h-4 w-4 border-gray-300 text-[#49BCD2] focus:ring-[#49BCD2]"
              onChange={(e)=>{setSearchEngine(e.target.id)}}
            />
            <label htmlFor={notificationMethod.id} className="ml-3 block text-sm font-medium leading-6 text-gray-900">
              {notificationMethod.title}
            </label>
          </div>
        ))}
      </div>

        </div> */}

        <div className='flex flex-col mt-4 border-gray-200  border-solid border-[1px] py-3 px-2 rounded-md'>
        <div className='text-xs'>Select AI:</div>
        <SimpleSelect
                      people={aiOptions}
                      selected={selectedAi}
                      setSelected={setSelectedAi}
                      dropClass={true}
                    />
        </div>
        <div className='flex flex-col mt-4 border-gray-200  border-solid border-[1px] py-3 px-2 rounded-md'>
        <div className='text-xs'>{`Sort By`}</div>
        <SimpleSelect
                      people={sortByOptions}
                      selected={selectedSortBy}
                      setSelected={setSelectedSortBy}
                      dropClass={true}
                    />
        </div>
        <div className='flex flex-col mt-4 border-gray-200  border-solid border-[1px] py-3 px-2 rounded-md'>
        <div className='text-xs'>{`Human Response`}</div>
        <textarea
                  type="text"
                  rows={5}
                  name="aboutSeller"
                  value={humanResponse}
                  onChange={(e)=>{setHumanResponse(e.target.value)}}
                  className="block mr-2 w-full border-0 p-2 text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
                  placeholder="Enter Text Here"
                />
        </div>
        <div></div>
        <div></div>
    </div>
    </>
  )
}

export default SettingAdvanceIntent